import type { RotasDoModulo } from '@/app/rotas';
import { PlatformLayout } from '@/features/platform/PlatformLayout';

import { CompanyConsumptionPage } from './CompanyConsumptionPage';
import { PlatformCreditConsumptionPage } from './PlatformCreditConsumptionPage';

/**
 * Consumo das consultas ao bureau (C-VGD): o relatorio da empresa, dentro da moldura
 * da empresa, e os precos e o consumo de todas as empresas, na moldura da
 * administracao da plataforma.
 */
export const rotas: RotasDoModulo = {
  moldura: [
    { path: '/configuracoes/credito/consumo', element: <CompanyConsumptionPage /> },
  ],
  avulsas: [
    {
      path: '/admin/credito/consumo',
      element: <PlatformLayout />,
      exigeSessao: true,
      filhas: [{ index: true, element: <PlatformCreditConsumptionPage /> }],
    },
  ],
};
